export function usuarioSoloUnaEmpresa(user) {
  return Boolean(user?.empresa_id);
}

export function empresaIdAsignada(user) {
  return user?.empresa_id ? Number(user.empresa_id) : null;
}
